module.exports = __webpack_public_path__ + "img/analyse.da94ec84.png";